import { createContext, useContext, type ReactNode } from 'react';

/* eslint-disable react-refresh/only-export-components -- colocated hook + provider for layout context */

export type OnboardingLayoutContextValue = {
  currentStep: number;
  totalSteps: number;
  onBack: () => void;
  onForward: () => void;
  forwardLabel: ReactNode;
  forwardDisabled: boolean;
  /** Dims the primary CTA to look disabled while keeping it clickable (e.g. to surface validation). */
  forwardInactive: boolean;
  hideForward: boolean;
  forwardBusy: boolean;
};

const OnboardingLayoutContext = createContext<OnboardingLayoutContextValue | null>(null);

export function OnboardingLayoutContextProvider({
  value,
  children,
}: {
  value: OnboardingLayoutContextValue;
  children: ReactNode;
}) {
  return <OnboardingLayoutContext.Provider value={value}>{children}</OnboardingLayoutContext.Provider>;
}

export function useOnboardingLayout(): OnboardingLayoutContextValue {
  const ctx = useContext(OnboardingLayoutContext);
  if (!ctx) {
    throw new Error('useOnboardingLayout must be used within OnboardingLayout');
  }
  return ctx;
}
